module.exports = __webpack_public_path__ + "img/0b356bb507d64b9489e2fbced131f795.8426a514.png";